<template>
  <v-container class="page-header pb-2 pt-6 px-4">
    <v-btn class="ml-n3 mb-1"
           exact
           text
           v-bind:to="backTo"
           v-if="backTo != null">
      <v-icon left>mdi-chevron-left</v-icon>
      {{ backLabel }}
    </v-btn>
    <h1 class="font-weight-bold text-h5 text-sm-h4">{{ title }}</h1>
    <p class="mb-0 mt-1 text--secondary"
       v-if="subtitle != null">
      {{ subtitle }}
    </p>
  </v-container>
</template>

<script>
  export default {
    name: 'PageHeader',
    props: {
      backLabel: String,
      backTo: Object,
      subtitle: String,
      title: String
    }
  }
</script>
